// Testnet users who independently opened positions on the prediction market.
// Generated: 2026-06-20
//
// Each user has a funded Stellar testnet account, bought shares via the
// Soroban contract, and has a live Position entry on-chain.
//
// Market 1: "Will Bitcoin reach $100,000?"  (BTC)
// Market 2: "Will Solana reach $100?"        (SOL)

const TESTNET_USERS = [
  // ── Market 1 (Bitcoin) — mostly YES, a few contrarians ──
  { publicKey: 'GASWZCDMVEGOUWJIBVIRY6UXURRAW6DLNQ6QOBQIIFD7HLA5HWTLOQAM', marketId: 1 },
  { publicKey: 'GBYQ22V4JHFSXTY6DFHVLVFETJ5AX6EC3PIMHXJEBRDXAPZHPDCNMCYT', marketId: 1 },
  { publicKey: 'GDJXTML5GEO4CFTUIMMGCH5AUD5BM6PDQ2AFAGFLSEFCOFTKXTZYZVKK', marketId: 1 },
  { publicKey: 'GBKFCLBRT3GHFWUOXLIFGKUPZPHUCMM5NRLCXXCA6Z6P5ONRJQX32E54', marketId: 1 },
  { publicKey: 'GBADX2MFGQSOP64V4YCJ7BKIOFRB43FNRQKC5FTGRQBJ2NKNHF45DACK', marketId: 1 },
  { publicKey: 'GDFOZ37OYRQL2KSQEUPEQ6Q5NT4YQDYZNS7ZVY46IGE7O226HAZ47QJW', marketId: 1 },
  { publicKey: 'GC7SVVUCMWN7ISOGUPNNBPOCCUN354DDAL3XKNZY4AD2TRQI324GUV6I', marketId: 1 },
  { publicKey: 'GCOPVCR4NRYRVIPNYCOOS2IS3ONFH6FSMAH6LUGVM6JKEGY2PX5CFTHE', marketId: 1 },
  { publicKey: 'GCNQ5IDACBPBA6DGMY6MISV5IWHKMBB7MHNZDTWMDDJ2ZF72MVS735FX', marketId: 1 },
  { publicKey: 'GDJXDEEJ2NXQRPIPJZL4SVBXDMLZHABMJNYDQFU6WBYHF6BNCJMSRL7B', marketId: 1 },
  { publicKey: 'GDQZSIIEHQS4XI7AYDIZBKPU75ZD56KLEBG467ZGIMKECTNATVOY2HQS', marketId: 1 },
  { publicKey: 'GCR7VHM75YY7JOSQJJOPQ5ZIKYTRJRDVPEUTVNAB275R4465ZLHVGAJE', marketId: 1 },
  { publicKey: 'GACHT2QNUIOQ4HZHSPQPOT77RWFGZHBWHK4OLQYPAITLRNLBCSJSCMSM', marketId: 1 },
  { publicKey: 'GDDG6H3OJ6NA5RFTBQ7ITFB36UQZJOLGDV64AEH7V6RWKBAT7I4A3X7T', marketId: 1 },
  { publicKey: 'GDXHDZQBFFCWXL2VW473TQV5CQH46ORUVXMHXZZJ3D34M2DGIQKVXXKH', marketId: 1 },
  { publicKey: 'GAYRR4RGFUPHCLYHJHMYUJIITEAVB7GF5FZH5I63ZGQMIBXDNTWEDRNC', marketId: 1 },
  { publicKey: 'GDZNI7567FQZKGUI27OKGMTGATAS2DBALSQXRPD255KLP6CLP4HKARNX', marketId: 1 },
  { publicKey: 'GAVRLWRSOTHT3YVKOI3FZHM45T25LRBB3WTHLGJZFWYZIHZM2ODSMCUW', marketId: 1 },
  { publicKey: 'GDKQTPB4NUZGWUUEUGOSZWWQVGFIKQD43NC7MSJ7RS36WGDM4B3J276K', marketId: 1 },
  { publicKey: 'GAJLMQYKV7N6ENL34MIBTTA6WFM3L2KESEHJEKAARROFUEP6LDTP4LSM', marketId: 1 },
  { publicKey: 'GBN57CCIJUN4HGUQYOBFXU7IMQ7D7R7GXNPIYG434QVL3BGT5VDRQ6BG', marketId: 1 },
  { publicKey: 'GBYXASXTNECTAYNHWXFTRXR5SZEECAHLFAY4AXWRO6SFH4B7BEFM2OJ4', marketId: 1 },
  { publicKey: 'GDFUUGU3F3ZEDXQX3S3ALYTETQ4CWEIOGPONKZKQTHI4CHKX5QBVCNWS', marketId: 1 },
  { publicKey: 'GAPEEB3LDQHSIBD77S43GZ2R6C3R2FACEXNJKWNGGGMRWN6F35QUG7LO', marketId: 1 },
  { publicKey: 'GAEHK7NTW7JGPEZIWKGTU42ELOWPDPNTEA55O4LFCGNK3IGWOZTDY2VN', marketId: 1 },
  { publicKey: 'GCQJJJPYUV2RE2ZE47U3QMLBKMZ4SUEIPZOMF44QXZJUQFHWG7BY23RH', marketId: 1 },
  { publicKey: 'GDS3WSX6PEVBKWP3OY6NE6XAHDTPFDIGUF4T5IASVTGN7P4V5OGKHAXP', marketId: 1 },
  { publicKey: 'GAEKZ2F4REQ3EIATZ4Z6CUFME7C4WZSVH4RXJYM4AINOJN62ZBFLP2YF', marketId: 1 },
  { publicKey: 'GBVNXE7G76MNOFTED326T3SAQ3NAX5P3F37NUVW6IWUALEKJI4GANSGE', marketId: 1 },
  { publicKey: 'GDWQVBGXP7HQDHYITJZG3ETFOP5N3LRZZRJKLIBVYYPXSKNKKEK3OIP5', marketId: 1 },
  { publicKey: 'GC2ZNMALJTN36MOIFTWIA4OWM7CG77NOOBQCICW5NIT5MAWKKT4JD4CP', marketId: 1 },
  { publicKey: 'GAUYBOO7SMIVUESF5DG372BAC6KM6I2R23Z57Q2YIRCDJZH32VZ5Y5YN', marketId: 1 },
  { publicKey: 'GBISYIHHLGTKL6M35UBMQHYLP6DLUI4CWH5HE6ZAPMSVMPZTUPZEE62D', marketId: 1 },
  { publicKey: 'GDI24Z3EVI4K3B57NE7HN6SY7PA57RY3XDTZTHOXLMXMU3RCVHXVYADQ', marketId: 1 },
  { publicKey: 'GB73EAQ7W2EHR2NTWE52DEXILILH3XTATVRP5MSGTLOEUF6VROAV46IC', marketId: 1 },
  { publicKey: 'GDWBRGMXRAGRSK4MHPRUOSDCRHGK65Z6G3WR63VHQDY2PZAUEWX73UEY', marketId: 1 },
  { publicKey: 'GDGFNQ2DYNBNNALGQ34C63DI3JVDIFO5LEKDUS4PYWFPLEFUS2QGNZ3I', marketId: 1 },
  { publicKey: 'GADWBJN2K53OFOQO3IOJI2OGT4HKAGKRZPLAPEQHRU2QWE7OUUKUESQZ', marketId: 1 },
  { publicKey: 'GAA4QGEKJF5KOEIO3M7QZDWAPTLFCXK27JF7BZM2USZ567PU6SKR232R', marketId: 1 },
  { publicKey: 'GANOJK55DAH6DNGTXNZMGEQAZUPBTU36PCR62EPGROQ6VD6B7QDK4B7F', marketId: 1 },
  { publicKey: 'GBMIP44EQ3IRRQBS7NJWZJMJ7BVWFWLRBOF3PBTMAJQOQPJKUF3QPGFQ', marketId: 1 },
  { publicKey: 'GDSATCARZXZZHZ54HLWA33WHSUBODZTAUO7OPKUIAHE4B6DWKKZ5SMXE', marketId: 1 },
  { publicKey: 'GDYESZFEOYRUJW4NXDS7YHAPV4UIRXAL6UWB2553ZDITBBOSSJMFSYSP', marketId: 1 },
  { publicKey: 'GDJ6FZZK2UARQEGQKKAA7BNG46U2SVDEERYAHV7AS2FQWJPBVREFZL4Y', marketId: 1 },
  { publicKey: 'GDH2OTVNX3GBQ63QATSNPZMLBPQQW7UN6UCA4ORUCPLBKFOF6S5YCP6E', marketId: 1 },
  { publicKey: 'GB46EWEIAV4N6ZAFKX4ZUJWR7GBVU37JM7WABNHRO7NZ33TRTXZGKIUD', marketId: 1 },
  { publicKey: 'GBSGYKWPSDJTFPDSQLIINI427E7VWKALPX5N27PPE4JZEMUNS4HBOOG6', marketId: 1 },
  { publicKey: 'GBWDRGM33LGUS2PWIRATD7ECBEJZVZBN6BIO4XJZUMXI67X5KDDXG5CW', marketId: 1 },
  { publicKey: 'GCKG2VEWRFXFSVTU3OZEVR47YP3C6A5Z2MTBAJBM43ITMYV363MDC7CK', marketId: 1 },
  { publicKey: 'GCS4Q3NRECZOPGKC42WO3KGHZ2NIGZPJ3UCQOWLKHXROHXABHIT2VEO7', marketId: 1 },

  // ── Newer / larger positions ──
  { publicKey: 'GD6FCWOKPAXQFXBHCSKM5MYPF45DMEW2TMN76UHUTRUW3THZV5HWWFLE', marketId: 1 },  // BTC YES 2.5 XLM
  { publicKey: 'GBR3BU2R6X6GIVJVOL6EWSKVZZY2HQMSIYMDZYSZXGHJI7ZA2NH5RKDG', marketId: 1 },  // BTC YES 0.5 XLM
  { publicKey: 'GA5LPIYE7WYBNCY5DUEPGOFGJYXKPM2V3BBSXQGDLX5S7LE5UB337I74', marketId: 1 },  // BTC NO  2 XLM (bearish)
  { publicKey: 'GBS5QXE5EJDSFCOQRYFA66ZLQO53TB3XSDC3AH5I2BZRELNSFWJABJNC', marketId: 1 },  // BTC NO  1 XLM (bearish)

  // ── Market 2: Solana ──
  { publicKey: 'GBE7BKNYA3MIXJSSTZ5IR4FHTSTX5XM5BVWYNP2QPHPPAZFJ3375WUTY', marketId: 2 },  // SOL YES 1 XLM
  { publicKey: 'GDRREOHCP3C5CSXZTW7DIVQNA3E6ZL65HZRYP722F2D2KBVBDOP5TL5K', marketId: 2 },  // SOL NO  1.5 XLM
  { publicKey: 'GB7TAXJHHMKYJN433RLGDY4LJZYDY7NZVQG3ONNO76GXWW4QQWMJCGFA', marketId: 2 },  // SOL YES 0.5 XLM
]

export const MARKET_NAMES = {
  1: { question: 'Will Bitcoin reach $100,000?', short: 'Bitcoin $100K' },
  2: { question: 'Will Solana reach $100?', short: 'Solana $100' },
}

export default TESTNET_USERS
